import { PRODUCT_TYPES } from './CurrentDocument';


export default PRODUCT_TYPES;
